export enum CollectionTab {
  Content = 0,
  Assets = 1,
  Analytics = 2,
  Monetization = 3,
}

export const collectionTabLabels: Record<CollectionTab, string> = {
  [CollectionTab.Content]: 'Content',
  [CollectionTab.Assets]: 'Assets',
  [CollectionTab.Analytics]: 'Analytics',
  [CollectionTab.Monetization]: 'Monetization Model',
};

export const collectionTabs: CollectionTab[] = [
  CollectionTab.Content,
  CollectionTab.Assets,
  CollectionTab.Analytics,
  CollectionTab.Monetization,
];
